export const pricingPlans = [
  {
    id: 'monthly',
    key: 'pricing.monthly',
    priceKey: 'pricing.monthlyPrice',
    periodKey: 'pricing.perMonth',
    featuresKey: 'pricing.monthlyFeatures',
    highlighted: false,
    icon: 'ri-calendar-line',
  },
  {
    id: 'semester',
    key: 'pricing.semester',
    priceKey: 'pricing.semesterPrice',
    periodKey: 'pricing.perSemester',
    featuresKey: 'pricing.semesterFeatures',
    highlighted: false,
    icon: 'ri-calendar-check-line',
  },
  {
    id: 'yearly',
    key: 'pricing.yearly',
    priceKey: 'pricing.yearlyPrice',
    periodKey: 'pricing.perYear',
    featuresKey: 'pricing.yearlyFeatures',
    highlighted: true,
    badgeKey: 'pricing.bestOffer',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 'school',
    key: 'pricing.school',
    priceKey: 'pricing.schoolPrice',
    periodKey: 'pricing.perQuarter',
    featuresKey: 'pricing.schoolFeatures',
    highlighted: false,
    icon: 'ri-graduation-cap-line',
  },
  {
    id: 'camp',
    key: 'pricing.camp',
    priceKey: 'pricing.campPrice',
    periodKey: 'pricing.perSession',
    featuresKey: 'pricing.campFeatures',
    highlighted: false,
    icon: 'ri-sun-line',
  },
];